import Model, { ID, IsoDateTime, JsonArray, MODEL_LEVEL } from 'src/models/model'

export const PRINTER_TYPE_OPTIONS = {
  EPSON_STAR: 'Epson/Star',
  BOCA: 'Boca'
}

PRINTER_TYPE_OPTIONS.ALL = _.values(PRINTER_TYPE_OPTIONS)

export const BOCA_TEMPLATE_TYPES = {
  TICKET: 'ticket',
  GIFT_CARD: 'gift-card',
  VOUCHER: 'voucher'
}

BOCA_TEMPLATE_TYPES.ALL = _.values(BOCA_TEMPLATE_TYPES)

export const DPI_OPTIONS = [200, 300]

export const BOCA_COMPUTED_TEXT = [
  { name: 'showing_date_time', label: 'Showing Date And Time', exampleText: '2023/10/23, 10:00pm', templateType: BOCA_TEMPLATE_TYPES.TICKET },
  { name: 'showing_time', label: 'Showing Time', exampleText: '10:00pm', templateType: BOCA_TEMPLATE_TYPES.TICKET },
  { name: 'showing_date', label: 'Showing Date', exampleText: '2023/10/23', templateType: BOCA_TEMPLATE_TYPES.TICKET },
  { name: 'movie_name', label: 'Movie Title', exampleText: 'Mission: Impossible - Ghost Protocol', templateType: BOCA_TEMPLATE_TYPES.TICKET },
  { name: 'ticket_id', label: 'Ticket Id (For QR)', exampleText: '12345678', templateType: BOCA_TEMPLATE_TYPES.TICKET },
  { name: 'ticket_type_name', label: 'Ticket Type Name', exampleText: 'Concession', templateType: BOCA_TEMPLATE_TYPES.TICKET },
  { name: 'ticket_price', label: 'Ticket Price', exampleText: '$10.50', templateType: BOCA_TEMPLATE_TYPES.TICKET },
  { name: 'screen_name', label: 'Screen Name', exampleText: 'Cinema 7', templateType: BOCA_TEMPLATE_TYPES.TICKET },
  { name: 'seat_name', label: 'Seat Name', exampleText: 'A3', templateType: BOCA_TEMPLATE_TYPES.TICKET },
  { name: 'raw', label: 'Text', templateType: BOCA_TEMPLATE_TYPES.TICKET },
  { name: 'gift_card_uid', label: 'Gift Card Id', exampleText: '12345678', templateType: BOCA_TEMPLATE_TYPES.GIFT_CARD },
  { name: 'gift_card_value', label: 'Value', exampleText: '$10', templateType: BOCA_TEMPLATE_TYPES.GIFT_CARD },
  { name: 'gift_card_expiry', label: 'Expiry Date', exampleText: '2023/09/12', templateType: BOCA_TEMPLATE_TYPES.GIFT_CARD },
  { name: 'raw', label: 'Text', templateType: BOCA_TEMPLATE_TYPES.GIFT_CARD },
  { name: 'voucher_uid', label: 'Voucher Id (For QR)', exampleText: '12345678', templateType: BOCA_TEMPLATE_TYPES.VOUCHER },
  { name: 'voucher_expiry', label: 'Expiry Date', exampleText: '2023/09/12', templateType: BOCA_TEMPLATE_TYPES.VOUCHER },
  { name: 'voucher_type_name', label: 'Voucher Type Name', exampleText: 'Adult Ticket Voucher', templateType: BOCA_TEMPLATE_TYPES.VOUCHER },
  { name: 'raw', label: 'Text', templateType: BOCA_TEMPLATE_TYPES.VOUCHER }
]

export const BOCA_FONTS = [
  { name: 'Extra Large Font', font: 'F12', size: 26, style: 'letter-spacing: 4px; font-weight: 800;', fontFamily: 'serif', type: 'text' },
  { name: 'Large Font', font: 'F6 ', size: 16, style: 'letter-spacing: 4px;', fontFamily: 'sans-serif', type: 'text' },
  { name: 'Medium Font', font: 'F11', size: 14, style: 'letter-spacing: 1px; font-style: italic;', fontFamily: 'sans-serif', fontWeight: 100, type: 'text' },
  { name: 'Small Font', font: 'F3', size: 10, style: 'letter-spacing: 1px;', fontFamily: 'sans-serif', type: 'text' },
  { name: 'Extra Small Font', font: 'F9', size: 6.3, style: 'letter-spacing: 1px;', fontFamily: 'sans-serif', type: 'text' },
  { name: 'Tiny Font', font: 'F2', size: 6, fontFamily: '"Lucida Console", monospace;', type: 'text' },
  { name: 'QR Code', font: 'QR' },
  { name: 'Box', font: 'BX' }
]

export default class PrintTemplate extends Model {
  static name = 'PrintTemplate'

  static isConfiguration = true
  static deletable = true
  static duplicatable = true
  static paginate = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Site]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null
      },
      sections: {
        type: JsonArray,
        default: () => ([])
      },
      printerType: {
        type: String,
        default: PRINTER_TYPE_OPTIONS.EPSON_STAR
      },
      templateType: {
        type: String,
        default: BOCA_TEMPLATE_TYPES.TICKET
      },
      dpi: {
        type: Number,
        null: false,
        default: 300
      },
      bocaTemplateData: {
        type: JsonArray,
        default () {
          return []
        }
      },
      printerWidth: {
        type: Number,
        default: 5.5
      },
      printerHeight: {
        type: Number,
        default: 1.95
      },
      publishedAt: {
        type: IsoDateTime,
        output: true,
        default: null
      },
      action: {
        type: String,
        input: true,
        default: null
      }
    }
  }

  get isPublished () {
    return !!this.publishedAt
  }
}
